import { useDataChange } from 'Simple/Data.js'
export function useOnClick(props) {
  let change = useDataChange({
    context: 'requirement',
    viewPath: props.viewPath,
  })
  return function onClick() {
    change(next => {
      next.create_task = true
      next.create_task_new = false
    })
  }
}
